<template>
  <div class="ti1">抱歉!</div>
  <div class="ti1">您没有操作角色...</div>
  <div class="ti1">当前帐号没有操作角色,请联系管理员。</div>
  
  <div class="cron">
    <el-popover
      v-model:visible="state.cronPopover"
      width="700px"
      trigger="manual"
    >
      <vue3Cron
        @change="changeCron"
        @close="togglePopover(false)"
        i18n="cn"
        max-height="200px"
      ></vue3Cron>
      <!--  #reference -->
      <template #reference>
        <el-input
          @focus="togglePopover(true)"
          v-model="state.cron"
          placeholder="* * * * * ? *"
        ></el-input>
      </template>
    </el-popover>
  </div>
</template>
<script>
import { reactive } from "vue";
import { Vue3Cron } from "vue3-cron";

export default {
  template: "<cron/>",
  components: {
    Vue3Cron,
  },
  data() {
    return {
      state: reactive({
        cronPopover: false,
        cron: "",
      }),
    };
  },
  methods: {
    changeCron(val) {
      if (typeof val !== "string") return false;
      this.state.cron = val;
    },
    togglePopover(bol) {
      this.state.cronPopover = bol;
    },
  },
};
</script>
<style scoped>
.ti1 {
  font-size: 16px;
  color: #303133;
}
</style>
<style lang="scss" scoped>
.cron {
  width: 700px;
  margin: 0 auto;
  margin-top: 100px;
  overflow:inherit;
  h1 {
    font-size: 16px;
    text-align: center;
  }
}
</style>

